const AuthName = "auth";

export const GetAuth = () => localStorage.getItem(AuthName);
export const SetAuth = (newValue: string) =>
	localStorage.setItem(AuthName, newValue);
export const DelAuth = () => localStorage.removeItem(AuthName);
